
export default function (Component) {
  Component.options.__source = "src/components/DynamicPages/Customize/ProjectTree.vue"
}
